export const Russian = {
    translation:{
        title:"Привет. Я Мануэ <a href='https://githib.com/manuelbento19' target='_blank'><span>@manuelbento19</span></a></b>🤟",
        shortBio: [
            "Я инженер-программист с более чем 2-летним опытом работы в различных областях. Последние несколько лет я сосредоточился на высоконагруженных серверных проектах и ​​разработке платформ, работая с инфраструктурой и всем, что связано с контейнерами.",
            "Хотя обо мне нет страницы в Википедии (извините, ребята!), биография для СМИ доступна ниже."
        ],
        career: {
            title: "Каррер",
            content: "В качестве разработчика программного обеспечения для GrupoLider я отвечаю за разработку и поддержку приложений."
        },
        connect: {
            title: "Давайте соединимся",
            content: "Я рад общаться с другими людьми по электронной почте и в Твиттере, чтобы обсудить проекты и идеи. В настоящее время я не берусь за внештатные проекты, но я открыт для того, чтобы услышать о потенциальных возможностях, обсудить их с вами, а затем потенциально сотрудничать, если это вам подходит."
        },
        footer:{
            copyright: "Все права защищены",
            dev: "Разработано с ❤️ автором<b>Мануэль Канганджо</b>"
        }
    }
}